/*
  <solvera-sticky-buy> — mobile sticky purchase bar.
  Implements docs/experience/product-page-blueprint.md §4.

  Reveals a slim bottom bar (product thumb · price · add-to-bag) once the main
  buy button scrolls out of view. Uses IntersectionObserver (no scroll-thrash),
  deferred, dependency-free, honours prefers-reduced-motion, and forwards the
  tap to the real product-form submit so all Dawn cart behaviour is preserved.

  Markup contract (see implementation-build.md):
    <solvera-sticky-buy data-sv data-watch="#ProductSubmitButton-{id}">
      ...bar markup with a [data-sv-sticky-add] button...
    </solvera-sticky-buy>
  data-watch = selector of the in-page add-to-cart button to mirror/observe.
*/
(function () {
  if (customElements.get('solvera-sticky-buy')) return;

  class SolveraStickyBuy extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector(this.dataset.watch || '');
      this.trigger = this.querySelector('[data-sv-sticky-add]');
      if (!this.target) return;

      this.hide(); // start hidden

      this.observer = new IntersectionObserver(
        (entries) => {
          // Show the bar only while the real button is OFF screen.
          const visible = entries[0].isIntersecting;
          visible ? this.hide() : this.show();
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0 }
      );
      this.observer.observe(this.target);

      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          // Delegate to the real product form button (keeps Dawn cart/AJAX).
          this.target.click();
        });
      }

      this.watchForFab();
    }

    // Chat/WhatsApp FABs inject late, so poll (bounded) for a bottom-right
    // floating widget and reserve right-side space once, so the add-to-cart CTA
    // is never overlapped. App-agnostic; stops as soon as one is found.
    watchForFab() {
      let tries = 0;
      const check = () => {
        if (this.classList.contains('sv-sticky--has-fab')) return;
        if (this.scanFab()) { this.classList.add('sv-sticky--has-fab'); return; }
        if (++tries < 8) setTimeout(check, 1000);
      };
      check();
    }

    scanFab() {
      try {
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        for (const el of document.querySelectorAll('body *')) {
          if (el === this || this.contains(el)) continue;
          const cs = getComputedStyle(el);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          const r = el.getBoundingClientRect();
          if (!r.width || !r.height || r.width > 140) continue;
          if (r.bottom > vh - 170 && r.right > vw - 140) return true;
        }
      } catch (e) { /* non-critical */ }
      return false;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    show() {
      this.setAttribute('data-visible', '');
      this.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.removeAttribute('data-visible');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('solvera-sticky-buy', SolveraStickyBuy);
})();
